<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Detalhes do Prontuário familiar") }}
    </h1>

    <load v-if="loading" />
    <div v-else id="boxPrint" class="row">
      <div class="col-md-12">
        <print-header></print-header>
        <h4 class="text-center">Detalhes do Prontuário familiar</h4>
        <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td colspan="2">
                ID <strong>{{ item.id }}</strong>
              </td>
              <td>
                CADASTRADO
                <strong>{{ item.cadastrado }}</strong>
              </td>
              <td>
                ATUALIZADO
                <strong>{{ item.atualizado }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                TELEFONE UM
                <strong v-if="item.contatos[0]">{{
                  item.contatos[0].telefone_um
                  }}</strong>
              </td>
              <td>
                TELEFONE DOIS
                <strong v-if="item.contatos[0]">{{
                  item.contatos[0].telefone_dois
                  }}</strong>
              </td>
              <td>
                TELEFONE TRÊS
                <strong v-if="item.contatos[0]">{{
                  item.contatos[0].telefone_tres
                  }}</strong>
              </td>
              <td>
                TELEFONE QUATRO
                <strong v-if="item.contatos[0]">{{
                  item.contatos[0].telefone_quatro
                  }}</strong>
              </td>
            </tr>

            <tr>
              <td colspan="4">
                E-MAIL
                <strong v-if="item.contatos[0]">{{
                  item.contatos[0].email
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                FAMÍLIA EM SITUAÇÃO DE RUA?
                <strong>{{
                  pergunta(item.situacao_rua)
                  }}</strong>
              </td>
              <td>
                TRABALHO INFANTIL NA FAMÍLIA?
                <strong>{{
                  pergunta(item.trabalho_infantil)
                  }}</strong>
              </td>
              <td>
                FAMÍLIA FOI ATINGIDA POR SITUAÇÕES DE EMERGÊNCIA OU ESTADO DE CALAMIDADE PÚBLICA?
                <strong>{{ pergunta(item.catastrofe) }}</strong>
              </td>
              <td>
                FAMÍLIA MIGRANTE?
                <strong>{{ pergunta(item.migrante) }}</strong>
              </td>
            </tr>
            <tr v-if="item.migrante">
              <td colspan="2">
                ORIGEM
                <strong>{{ item.origem_migrante }}</strong>
              </td>
              <td colspan="2">
                DESTINO
                <strong>{{ item.destino_migrante }}</strong>
              </td>
            </tr>

            <tr v-if="item.familia_lgbtqia">
              <td colspan="4">
                Família composta por membro(s) LGBTQIAPN+?
                <strong v-if="item.familia_lgbtqia == 1">
                  SIM
                </strong>
                <strong v-else> NÃO </strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Caso o grupo familiar, em seu conjunto, já tenha
                vivenciado alguma situação de acolhimento
                institucional (abrigamento) decorrente da perda,
                temporária ou definitiva, do domicílio, quer em
                função de catástrofe natural ou de fatalidade
                pessoal, registre o período em que o fato
                ocorreu e o motivo/fato que levou ao acolhimento.
                <strong>{{ item.obs_acolhimento }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Caso alguma criança/adolescente da família
                esteja, ou já tenha estado, sob guarda (legal ou
                informal) de outra pessoa não residente no
                domicílio (família extensa, amigos, patrões,
                etc). registre o período em que o fato ocorreu,
                a razão pela qual ocorreu, a pessoa que esteve
                com a guarda e o nome da criança/adolescente.
                <strong>{{ item.obs_guarda }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center">Endereço Atual</h4>
        <table
          class="b-table table b-table b-table-stacked-md table-bordered table-sm bg-white bg-white b-table-stacked-md table-sm table-striped mb-3">
          <tbody>
            <tr>
              <td colspan="2">
                LOGRADOURO
                <strong>
                  {{ item.endereco.logradouro.tipo }}
                  {{
                    item.endereco.logradouro.nome_logradouro
                  }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>
                NÚMERO
                <strong>{{ item.endereco.numero_endereco }}</strong>
              </td>
              <td>
                BAIRRO/LOCALIDADE
                <strong v-if="item.endereco.localidade">
                  {{
                    item.endereco.localidade
                      ? item.endereco.localidade
                        .nome_localidade
                      : ""
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                CEP
                <strong>{{
                  item.endereco.logradouro.cep
                  }}</strong>
              </td>
              <td>
                COMPLEMENTO
                <strong>
                  {{ item.endereco.complemento_endereco }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>
                PONTO DE REFERÊNCIA
                <strong>
                  {{ item.endereco.referencia_endereco }} 
                </strong>
              </td>
              <td>
                ENDEREÇO DE ABRIGO?
                <strong v-if="item.endereco.abrigo">
                  SIM
                </strong>
                <strong v-else> NÃO </strong>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="item.animais.length > 0">
          <h4 class="text-center">Animais de estimação</h4>
          <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Especie</th>
                <th>Sexo</th>
                <th>Castrado</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(animal, index) in item.animais" :key="index">
                <td>{{ animal.nome }}</td>
                <td>{{ animal.especie }}</td>
                <td>{{ animal.sexo }}</td>
                <td>{{ animal.castrado }}</td>
                <td>{{ animal.created_at }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h4 class="text-center" v-if="item.ingresso">
          Forma de ingresso na unidade e motivo do primeiro
          atendimento
        </h4>
        <table v-if="item.ingresso" class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td colspan="2">
                De que forma a família (ou membro da família)
                acessou a Unidade para o primeiro atendimento?
                <p>
                  <strong>{{
                    verificarValueArray(
                      item.ingresso.forma,
                      $root.arrays.forma_ingresso
                    )
                  }}</strong>
                </p>
              </td>
              <td>
                Nome da unidade/órgão de origem:
                <strong>{{
                  item.ingresso.nome_unidade_origem
                  }}</strong>
              </td>
              <td>
                Contato do órgão/unidade:
                <strong>{{
                  item.ingresso.nome_contato_unidade_origem
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Quais as razões, demandas ou necessidades que
                motivaram o primeiro atendimento?
                <p>
                  <strong>{{
                    item.ingresso.descricao_ingresso
                    }}</strong>
                </p>
              </td>
              <td>
                Família, ou algum de seus membros, seja
                beneficiária de algum dos seguintes Programas
                Sociais
                <strong>{{
                  verificarValueArray(
                    item.ingresso
                      .beneficiaria_programa_ingresso,
                    $root.arrays.programas,
                    true
                  )
                }}</strong>
              </td>
              <td>
                Nome do programa prioritário:
                <strong>{{
                  item.ingresso.nome_programa_ingresso
                  }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center">Composição Familiar</h4>

        <table v-if="item.familiares.length > 0"
          class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nome Completo</th>
              <th>Posição Familiar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="familiar in item.familiares" :key="familiar.id">
              <td>
                {{ familiar.codigo_usuario_cadunico }}
              </td>
              <td>
                <strong>
                  <router-link :to="`/dashboard/usuario/edit/${familiar.id}`">{{
                    familiar.nome_completo
                    }}
                  </router-link>
                </strong>
                <br />
                NIS
                {{
                  familiar.documento
                    ? familiar.documento.nis
                    : "--"
                }}<br />
                Sexo
                <span v-for="sexo in item.configs.sexo" :key="sexo.id">
                  <span v-if="sexo.id == familiar.sexo">
                    {{ sexo.value }}
                  </span>
                </span>
                <br />
                Idade {{ familiar.idade }} ano(s)
              </td>
              <td>
                <span v-for="posicao in item.configs
                  .posicao_familiar" :key="posicao.key">
                  <span v-if="
                    posicao.key ==
                    familiar.posicao_familiar
                  ">
                    {{ posicao.value }}
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center" v-if="item.domicilio">
          Condições Habitacionais
        </h4>
        <table v-if="item.domicilio" class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td>
                Características do local onde está situado o
                domicílio:
                <strong>{{
                  verificarValueArray(
                    item.domicilio.local,
                    $root.arrays.local
                  )
                }}</strong>
              </td>
              <td>
                Tipo de residência :
                <strong>{{
                  verificarValueArray(
                    item.domicilio.tipo_residencia,
                    $root.arrays.tipo_residencia
                  )
                }}</strong>
              </td>
              <td>
                Quantos cômodos tem seu domicílio? :
                <strong>{{
                  item.domicilio.quant_comodos
                  }}</strong>
              </td>
              <td>
                Quantos cômodos tem seu domicílio? :
                <strong>{{
                  item.domicilio.quant_comodos_dormitorio
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Quanto é nº de pessoas do domicílio dividido
                pelo nº de dormitórios? :
                <strong>{{
                  item.domicilio.numero_pessoas_dormitorio
                  }}</strong>
              </td>
              <td>
                Material predominante no piso? :
                <strong>{{
                  verificarValueArray(
                    item.domicilio.material_piso,
                    $root.arrays.material_piso
                  )
                }}</strong>
              </td>
              <td>
                Material predominante na construção das paredes
                externas? :
                <strong>{{
                  verificarValueArray(
                    item.domicilio.material_paredes,
                    $root.arrays.material_paredes
                  )
                }}</strong>
              </td>
              <td>
                Possui água canalizada para, pelo menos, um
                cômodo? :
                <strong>{{
                  pergunta(item.domicilio.agua_canalizada)
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Forma de abastecimento de água utilizada no seu
                domicílio? :
                <strong>{{
                  verificarValueArray(
                    item.domicilio.forma_abastecimento_agua,
                    $root.arrays.forma_abastecimento_agua
                  )
                }}</strong>
              </td>
              <td>
                Na propriedade existe banheiro ou sanitário? :
                <strong>{{
                  pergunta(item.domicilio.banheiro)
                  }}</strong>
              </td>
              <td>
                De que forma é feito o escoamento do banheiro ou
                sanitário? :
                <strong>{{
                  verificarValueArray(
                    item.domicilio
                      .forma_escoamento_sanitario,
                    $root.arrays.forma_escoamento_sanitario
                  )
                }}</strong>
              </td>
              <td>
                Forma de coleta do lixo? :
                <strong>{{
                  verificarValueArray(
                    item.domicilio.destino_lixo,
                    $root.arrays.destino_lixo
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Forma de iluminação utilizada no seu domicílio?
                :
                <strong>{{
                  verificarValueArray(
                    item.domicilio.iluminacao,
                    $root.arrays.iluminacao
                  )
                }}</strong>
              </td>
              <td>
                Existe calçamento/pavimentação em frente ao seu
                domicílio? :
                <strong>{{
                  verificarValueArray(
                    item.domicilio.calcamento_pavimentacao,
                    $root.arrays.calcamento_pavimentacao
                  )
                }}</strong>
              </td>
              <td>
                Possui acessibilidade para pessoas com
                dificuldade de locomoção? :
                <strong>{{
                  pergunta(
                    item.domicilio.acessibilidade_locomocao
                  )
                }}</strong>
              </td>
              <td>
                Domicílio localizado em área de risco de
                desabamento ou alagamento? :
                <strong>{{
                  pergunta(item.domicilio.area_risco)
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Domicílio localizado em área de difícil acesso
                geográfico? :
                <strong>{{
                  pergunta(item.domicilio.area_dificl_acesso)
                  }}</strong>
              </td>
              <td>
                Domicílio localizado em área com forte presença
                de conflito/violência? :
                <strong>{{
                  pergunta(
                    item.domicilio.area_conflito_violencia
                  )
                }}</strong>
              </td>
              <td>
                Outras observações referentes ao diagnóstico das
                condições habitacionais da família :
                <strong>{{
                  item.domicilio.observacoes_domicilio
                  }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center">Condições Educacionais</h4>
        <div v-for="usuario in item.familiares" :key="usuario.id">
          <div class="p-0 col-12 mb-3">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr class="col-12">
                  <td colspan="2">
                    <router-link :to="'/dashboard/usuario/edit/' +
                      usuario.id
                      ">
                      <strong>
                        {{ usuario.nome_completo }}
                      </strong>
                    </router-link>
                    <br />
                    Idade: {{ usuario.idade }} ano(s)<br />
                  </td>
                </tr>
                <tr>
                  <th>Sabe ler e escrever?</th>
                  <td v-if="usuario.escolaridade[0]">
                    {{
                      usuario.escolaridade[0].sabe_ler !=
                        null
                        ? usuario.escolaridade[0]
                          .sabe_ler == 1
                          ? "Sim"
                          : "Não"
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Frequenta escola atualmente?</th>
                  <td v-if="usuario.escolaridade[0]">
                    {{
                      findFrequentaEscola(
                        usuario.escolaridade[0]
                          .frequenta_escola
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Escolaridade</th>
                  <td v-if="usuario.escolaridade[0]">
                    {{
                      usuario.escolaridade[0]
                        .frequenta_escola == "1" ||
                        usuario.escolaridade[0]
                          .frequenta_escola == "2"
                        ? findFrequenta(
                          usuario.escolaridade[0]
                            .curso_frequenta
                        )
                        : findFrequentou(
                          usuario.escolaridade[0]
                            .curso_frequentou
                        )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <thead>
            <tr>
              <th>Faixas Etárias</th>
              <th>Qtd. de Pessoas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="perfil in $root.arrays.perfil_etario_escolar" :key="perfil.id">
              <td>{{ perfil.value }}</td>
              <td>
                <span v-for="familiar in item.familiares" :key="familiar.id">
                  <span v-if="
                    familiar.perfil_etario_escolar ==
                    perfil.id
                  "><i class="fas fa-user"></i>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center">
          Anotações sobre o não cumprimento das condicionalidades de educação no {{ $t("Bolsa Família") }}
        </h4>
        <div v-for="(usuario, index) in item.descumprimentos" :key="usuario.id">
          <div class="p-0 col-12 mb-3" v-if="usuario.tipo == 'educacao'">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr class="col-12">
                  <td colspan="2">
                    <router-link :to="'/dashboard/usuario/edit/' +
                      usuario.id
                      ">
                      <strong>
                        {{
                          usuario.usuario_id
                            .nome_completo
                        }}
                      </strong>
                    </router-link>
                    <br />
                    Idade:
                    {{ usuario.usuario_id.idade }}
                    ano(s)<br />
                  </td>
                </tr>
                <tr>
                  <th>Data da ocorrência</th>
                  <td>{{ usuario.data_ocorrencia }}</td>
                </tr>
                <tr>
                  <th>Efeito</th>
                  <td>
                    <span class="text-warning">{{
                      checkEfeito(usuario.efeito)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Solicitada suspensão do efeito?</th>
                  <td>
                    {{
                      usuario.solicitada_suspensao == 1
                        ? "Sim"
                        : "Não"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else>
            <h4 class="text-secondary" v-if="index == item.descumprimentos.length - 1">
              <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
              Não há informações disponíveis para visualização.
            </h4>
          </div>
        </div>
        <h4 class="text-center">Condições Financeiras</h4>
        <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td>
                Renda total da família <br /><strong>R$ {{ renda_total_familiar }}</strong>
              </td>
              <td>
                Valor da renda média (per capita) da família:
                <br /><strong>R$ {{ per_capita_familiar }}</strong>
                <label v-if="per_capita_familiar <= 89" class="badge badge-danger">Pobreza</label>
                <label v-if="
                  per_capita_familiar > 89 &&
                  per_capita_familiar <= 218
                " class="badge badge-warning">Pobreza</label>
                <label v-if="per_capita_familiar > 311" class="badge badge-primary">
                  Perfil Cadunico
                </label>
              </td>
            </tr>
            <tr>
              <td>
                Renda total da família (incluindo programas
                sociais): <br />
                <strong v-if="item.financeiro">
                  R$
                  {{
                    sumRendas +
                    beneficiosValor +
                    programasValor
                  }}
                </strong>
              </td>
              <td>
                Renda familiar per capita (incluindo programas
                sociais)<br />
                <strong v-if="item.financeiro">
                  R$
                  {{
                    per_capita_familiar +
                    beneficiosValor +
                    programasValor
                  }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center">
          Ocupação e qualificação dos familiares
        </h4>
        <div v-for="usuario in item.familiares" :key="usuario.id">
          <div class="p-0 col-12 mb-3" v-if="usuario.remuneracao[0]">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr class="col-12">
                  <td colspan="2">
                    <router-link :to="'/dashboard/usuario/edit/' +
                      usuario.id
                      ">
                      <strong>
                        {{ usuario.nome_completo }}
                      </strong>
                    </router-link>
                    <br />
                    Idade: {{ usuario.idade }} ano(s)<br />
                  </td>
                </tr>
                <tr>
                  <th>Possui Carteira de Trabalho?</th>
                  <td>
                    {{
                      usuario.documento
                        ? usuario.documento.ctps
                          ? "Sim"
                          : "Não"
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Condição de Ocupação</th>
                  <td>
                    {{
                      findJob(
                        usuario.remuneracao[0]
                          .profissao_principal
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Possui qualificação profissional?</th>
                  <td>
                    {{
                      usuario.remuneracao[0]
                        .qualificacao_profissional == 1
                        ? "Sim " +
                        changeNome(
                          usuario.remuneracao[0]
                            .profissao_nome
                        )
                        : "Não"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h4 class="text-center" v-if="item.financeiro">
          Despesas mensais da familia
        </h4>
        <table v-if="item.financeiro" class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td>
                Energia elétrica
                <strong>R$
                  {{
                    item.financeiro.val_desp_energia
                  }}</strong>
              </td>
              <td>
                Água e esgoto
                <strong>R$
                  {{ item.financeiro.val_desp_agua }}</strong>
              </td>
              <td>
                Gás, carvão e lenha
                <strong>R$
                  {{ item.financeiro.val_desp_gas }}</strong>
              </td>
              <td>
                Alimentação, higiene e limpeza
                <strong>R$
                  {{
                    item.financeiro.val_desp_alimentacao
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Transporte
                <strong>R$
                  {{
                    item.financeiro.val_desp_transporte
                  }}</strong>
              </td>
              <td>
                Aluguel
                <strong>R$
                  {{
                    item.financeiro.val_desp_aluguel
                  }}</strong>
              </td>
              <td>
                Medicamentos de uso regular
                <strong>R$
                  {{
                    item.financeiro.val_desp_medicamentos
                  }}</strong>
              </td>
              <td>
                Outras despesas
                <strong>R$
                  {{
                    item.financeiro.val_desp_outros
                  }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center">Condições de Saúde</h4>
        <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td>
                A família declara, ou fornece indícios, de que vivencia situação de insegurança alimentar devido à
                insuficiência de alimentos?
                <strong v-if="item.caracteristicas">{{
                  pergunta(
                    item.caracteristicas.ind_risco_inseguranca_alimentar
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>

        <h4 class="text-center">Pessoa(s) com Deficiência</h4>
        <div v-for="(usuario, index) in item.familiares" :key="index">
          <div class="p-0 col-12 mb-3" v-if="
            usuario.saude[0] &&
            (usuario.saude[0].uso_abusivo_alcool == 1 ||
              usuario.saude[0].uso_abusivo_drogas == 1 ||
              usuario.saude[0].uso_remedio_controlado == 1)
          ">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr class="col-12">
                  <td colspan="2">
                    <router-link :to="'/dashboard/usuario/edit/' +
                      usuario.id
                      ">
                      <strong>
                        {{ usuario.nome_completo }}
                      </strong>
                    </router-link>
                    <br />
                    Idade {{ usuario.idade }} ano(s)<br />
                  </td>
                </tr>
                <tr>
                  <th>Tipo de deficiência :</th>
                  <td>
                    {{
                      usuario.saude[0]
                        .uso_remedio_controlado == 1
                        ? "Sim"
                        : "Não"
                    }}
                  </td>
                </tr>
                <tr>
                  <th>
                    Necessita de cuidados constantes de
                    outra pessoa
                  </th>
                  <td>
                    {{
                      usuario.saude[0].ajuda_familia ==
                        1 ||
                        usuario.saude[0]
                          .ajuda_especializada == 1 ||
                        usuario.saude[0]
                          .ajuda_instituicao == 1 ||
                        usuario.saude[0].ajuda_vizinhos ==
                        1 ||
                        usuario.saude[0]
                          .ajuda_outra_forma == 1
                        ? "Sim"
                        : "Não"
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Responsável pelo cuidado</th>
                  <td>
                    {{ usuario.saude[0].responsavel_nome }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <h4 class="text-center" v-if="index == item.familiares.length - 1">
              <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
              A familia não possui Pessoa(s) com Deficiência.
            </h4>
          </div>
        </div>
        <h4 class="text-center">Gestante(s)</h4>
        <div v-if="item.gestantes.length == 0">
          <h4 class="text-center">
            <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
            A familia não possui gestantes.
          </h4>
        </div>
        <div v-for="usuario in item.gestantes" :key="usuario.id">
          <div class="p-0 col-12 mb-3">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr class="col-12">
                  <td colspan="2">
                    <router-link :to="'/dashboard/usuario/edit/' +
                      usuario.id
                      ">
                      <strong>
                        {{
                          usuario.usuario_id
                            .nome_completo
                        }}
                      </strong>
                    </router-link>
                    <br />
                    Idade
                    {{ usuario.usuario_id.idade }}
                    ano(s)<br />
                  </td>
                </tr>
                <tr>
                  <th>Quantos meses de gestação?</th>
                  <td>
                    {{ usuario.meses_gestacao }} mes(es)
                  </td>
                </tr>
                <tr>
                  <th>Já iniciou Pré-Natal</th>
                  <td>
                    {{
                      usuario.inicio_pre_natal == 1
                        ? "Sim"
                        : "Não"
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Data do Registro</th>
                  <td>{{ usuario.data_anotacao }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <b>Observação</b>
                    <p>{{ usuario.observacao }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-for="usuario in item.descumprimentos" :key="usuario.id">
          <div class="p-0 col-12 mb-3" v-if="usuario.tipo == 'saude'">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr class="col-12">
                  <td colspan="2">
                    <router-link :to="'/dashboard/usuario/edit/' +
                      usuario.id
                      ">
                      <strong>
                        {{
                          usuario.usuario_id
                            .nome_completo
                        }}
                      </strong>
                    </router-link>
                    <br />
                    Idade
                    {{ usuario.usuario_id.idade }}
                    ano(s)<br />
                  </td>
                </tr>
                <tr>
                  <th>Data da ocorrência</th>
                  <td>{{ usuario.data_ocorrencia }}</td>
                </tr>
                <tr>
                  <th>Efeito</th>
                  <td>
                    <span class="text-warning">{{
                      checkEfeito(usuario.efeito)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Solicitada suspensão do efeito?</th>
                  <td>
                    {{
                      usuario.solicitada_suspensao == 1
                        ? "Sim"
                        : "Não"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <h4 class="text-center" v-if="index == item.descumprimentos.length - 1">
              <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
              Não há informações a serem visualizadas.
            </h4>
          </div>
        </div>
        <h4 class="text-center" v-if="item.caracteristicas">
          Outras Características
        </h4>
        <table v-if="item.caracteristicas" class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td>
                A família está em risco de violação de direito?
                <strong>{{
                  verificarValueArray(
                    item.caracteristicas.ind_risco_violacao_direito,
                    $root.arrays.pergunta
                  )
                }}</strong>
              </td>
              <td>
                A família é indígena?
                <strong>{{
                  pergunta(
                    item.caracteristicas.familia_indigena
                  )
                }}</strong>
              </td>

              <td>
                Reside em reserva indígena
                <strong>{{
                  pergunta(
                    item.caracteristicas.indigena_reside
                  )
                }}</strong>
              </td>
              <td>
                Nome do povo indígena
                <strong>{{
                  item.caracteristicas.nome_povo_indigena
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Nome da reserva indígena
                <strong>{{
                  item.caracteristicas.nome_reserva_indigena
                  }}</strong>
              </td>
              <td>
                A família é quilombola?
                <strong>{{
                  pergunta(
                    item.caracteristicas.familia_quilombola
                  )
                }}</strong>
              </td>
              <td>
                Nome da comunidade quilombola
                <strong>{{
                  pergunta(
                    item.caracteristicas
                      .nome_comunidade_quilombola
                  )
                }}</strong>
              </td>
              <td>
                Quantas pessoas moram no seu domicílio? (Não
                preencher para famílias em situação de rua e
                famílias em domicílio coletivo)
                <strong>{{
                  pergunta(
                    item.caracteristicas
                      .qtd_pessoas_domicilio_etnia
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Quantas famílias moram no seu domicílio? (Não
                preencher para famílias em situação de rua e
                famílias em domicílio coletivo)
                <strong>{{
                  item.caracteristicas
                    .qtd_familias_domicilio_etnia
                }}</strong>
              </td>
              <td>
                Quantidade de criança(s) e adolescente(s) (de 0
                a 17 anos)"
                <strong>{{
                  item.caracteristicas.qtd_pessoa_inter_0_17
                  }}</strong>
              </td>
              <td>
                Quantidade de jovem(ns) e adulto(s) (de 18 a 64
                anos)"
                <strong>{{
                  item.caracteristicas.qtd_pessoa_inter_18_64
                  }}</strong>
              </td>
              <td>
                Quantidade de pessoa(s) idosa(s) (de 65 anos ou mais)"
                <strong>{{
                  item.caracteristicas.qtd_pessoa_inter_65
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                Centro de Referência da Assistência Social
                (CRAS/CREAS) em que os membros da família são
                atendidos quando necessitam.
              </td>
            </tr>
            <tr>
              <td>
                Nome do CRAS/CREAS
                <strong>{{
                  item.caracteristicas.nome_cras_creas
                  }}</strong>
              </td>
              <td>
                Código do CRAS/CREAS
                <strong>{{
                  item.caracteristicas.codigo_cras_creas
                  }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center" v-if="item.convivencia">
          Convivência Familiar e Comunitária
        </h4>
        <table v-if="item.convivencia" class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr>
              <td>
                Há quantos anos a família mora neste estado?
                <strong>{{
                  item.convivencia.qtd_mora_estado
                  }}</strong>
              </td>

              <td>
                Há quantos anos a família mora no município?
                <strong>{{
                  item.convivencia.qtd_mora_municipio
                  }}</strong>
              </td>

              <td>
                Há quantos anos a família mora no bairro atual?
                <strong>{{
                  item.convivencia.qtd_mora_bairro
                  }}</strong>
              </td>

              <td>
                A família, ou algum de seus membros, é vítima de
                ameaças ou de discriminação na comunidade onde
                reside?
                <strong>{{
                  pergunta(
                    item.convivencia
                      .discriminacao_convivencia
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                A família possui parentes que residam próximo ao
                seu local de moradia e que constituam rede de
                apoio e solidariedade?
                <strong>{{
                  pergunta(item.convivencia.apoio_parentes)
                  }}</strong>
              </td>

              <td>
                A família possui vizinhos que constituam rede de
                apoio e solidariedade?
                <strong>{{
                  pergunta(item.convivencia.apoio_vizinhos)
                  }}</strong>
              </td>

              <td>
                A família, ou algum de seus membros, participa
                de grupos religiosos, comunitários ou outros
                grupos/instituições que constituam rede de apoio
                e solidariedade?
                <strong>{{
                  pergunta(
                    item.convivencia.apoio_grupo_comunitario
                  )
                }}</strong>
              </td>

              <td>
                A família, ou algum de seus membros, participa
                de movimentos sociais, sindicatos, organizações
                comunitárias, Conselhos ou quaisquer outras
                ações ou instituições voltadas para organização
                política e defesa de interesses coletivos?
                <strong>{{
                  pergunta(
                    item.convivencia.grupos_sociais_defesa
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Existe alguma criança ou adolescente do grupo
                familiar que não tem acesso a atividades de
                lazer, recreação e convívio social?
                <strong>{{
                  verificarValueArray(
                    item.convivencia.cri_ado_acesso_lazer,
                    $root.arrays
                      .pergunta_cri_ado_acesso_lazer
                  )
                }}</strong>
              </td>

              <td>
                Existe alguma pessoa idosa do grupo familiar que não tem
                acesso a atividades de lazer, recreação e
                convívio social?
                <strong>{{
                  pergunta(
                    item.convivencia.idoso_acesso_lazer
                  )
                }}</strong>
              </td>

              <td>
                Há pessoas dependentes (crianças, pessoas idosas
                dependentes ou pessoas com deficiência) que
                permanecem períodos do dia em casa sem a
                companhia de um adulto?
                <strong>{{
                  verificarValueArray(
                    item.convivencia.dependente_cuidados,
                    $root.arrays
                      .pergunta_dependente_cuidados
                  )
                }}</strong>
              </td>

              <td>
                Percepção/Avaliação do técnico sobre as relações
                conjugais na família, se for o caso
                <strong>{{
                  verificarValueArray(
                    item.convivencia.relacoes_conjugais,
                    $root.arrays.relacoes_conjugais_familia
                  )
                }}</strong>
              </td>
            </tr>
            <tr>
              <td>
                Percepção/Avaliação do técnico sobre as relações
                entre pais/responsáveis e os filhos inclusive
                entre o padrasto ou madrasta com o(s)
                enteados(as), se for o caso
                <strong>{{
                  verificarValueArray(
                    item.convivencia.relacoes_responsaveis,
                    $root.arrays.relacoes_conjugais_familia
                  )
                }}</strong>
              </td>

              <td>
                Percepção/Avaliação do técnico sobre as relações
                entre os irmãos, se for o caso
                <strong>{{
                  verificarValueArray(
                    item.convivencia.relacoes_entre_irmaos,
                    $root.arrays.relacoes_conjugais_familia
                  )
                }}</strong>
              </td>

              <td>
                Indique se há relações conflituosas envolvendo
                outros indivíduos que residam no domicílio?
                <strong>{{
                  verificarValueArray(
                    item.convivencia
                      .relacoes_conflituosas_outros,
                    $root.arrays
                      .relacoes_conflituosas_outros
                  )
                }}</strong>
              </td>

              <td>
                Outras observações referentes ao diagnóstico das
                condições de convivência familiar e comunitária
                <strong>{{
                  item.convivencia.observavoes_comunitaria
                  }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="text-center">Programas e Serviços</h4>
        <div class="row">
          <div class="col-md-12">
            <h5 class="font-weight-bold">
              É beneficiário de algum programa da Secretária
              Nacional de Segurança Alimentar e Nutricional -
              SESAN?
            </h5>
          </div>
          <div class="col-md-12">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr v-for="item in $root.arrays
                  .beneficiario_sesan" :key="item.id">
                  <td v-if="checkSesan(item.id)">
                    <i :class="checkSesan(item.id)
                        ? 'mdi mdi-check'
                        : ''
                      "></i>
                    {{ item.value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12" v-if="item.programas_servicos">
            <h4 class="font-weight-bold">
              Algum membro da família foi resgatado do trabalho
              análogo ao de escravo por órgão do governo
              (Ministério Do Trabalho, Polícia Federal etc.)?
            </h4>
          </div>
          <div class="col-md-12">
            <table v-if="item.programas_servicos"
              class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr>
                  <td v-if="
                    item.programas_servicos
                      .errad_trab_escravo == 1
                  ">
                    <i :class="item.programas_servicos
                        .errad_trab_escravo == 1
                        ? 'mdi mdi-check'
                        : ''
                      "></i>
                    Resgatado do trabalho análogo ao de
                    escravidão
                  </td>
                  <td v-else>Nenhum(a)</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-md-12">
            <h5 class="font-weight-bold">
              É beneficiário de algum programa do ministério de
              minas e energia?
            </h5>
          </div>
          <div class="col-md-12">
            <table v-if="item.programas_servicos"
              class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr v-for="item in $root.arrays
                  .beneficiario_ministerio_minas_energia" :key="item.id">
                  <td v-if="checkSesan(item.id)">
                    <i :class="checkSesan(item.id)
                        ? 'mdi mdi-check'
                        : ''
                      "></i>
                    {{ item.value }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Número/código de identificação da
                    unidade consumidora, indicado na conta
                    de energia elétrica do domicílio:
                    <strong>{{
                      item.programas_servicos
                        .cod_cta_energ_unid_consum
                    }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 pt-3">
            <h5 class="font-weight-bold">
              É atendido por algum programa da l?
            </h5>
          </div>
          <div class="col-md-12">
            <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
              <tbody>
                <tr v-for="item in $root.arrays
                  .atendido_programa_assistencia_social" :key="item.id">
                  <td v-if="checkSesan(item.id)">
                    <i :class="checkSesan(item.id)
                        ? 'mdi mdi-check'
                        : ''
                      "></i>
                    {{ item.value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 px-0" v-if="item.programas_servicos">
            <div class="col-md-12 pt-3" v-if="item.programas_servicos.prog_prohab != 1">
              <h5 class="font-weight-bold">
                A familia ou algum membro da familia é
                beneficiário de algum programa do Ministério das
                Cidades
              </h5>
            </div>
            <div class="col-md-12" v-if="item.programas_servicos.prog_prohab != 1">
              <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
                <thead>
                  <tr>
                    <th>Pessoa</th>
                    <th>Programa</th>
                    <th>Natureza</th>
                    <th>Contrato</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="item.programas_prohab">
                    <td>
                      {{
                        item.programas_prohab.cod_pessoa
                      }}
                    </td>
                    <td>
                      {{
                        checkProhab(
                          item.programas_prohab
                            .programa
                        )
                      }}
                    </td>
                    <td>
                      {{
                        item.programas_prohab
                          .cod_natureza
                      }}
                    </td>
                    <td>
                      {{
                        item.programas_prohab
                          .cod_contrato
                      }}
                    </td>
                  </tr>
                  <tr v-else>
                    <td colspan="4">
                      Nenhum membro da familia é
                      beneficiário de algum programa do
                      Ministério das Cidades
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <h4 class="text-center">Pendências e Ocorrências</h4>
        <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
          <tbody>
            <tr v-for="(item, index) in $root.arrays
              .pendencias_familia" :key="index">
              <td v-if="checkPendencias(item.id) == true">
                <i :class="checkPendencias(item.id)
                    ? 'mdi mdi-close'
                    : ''
                  "></i>
                {{ item.value }}
              </td>
              <td v-if="
                index == 0 &&
                checkPendencias(item.id) == null
              ">
                Nenhum(a)
              </td>
            </tr>
          </tbody>
        </table>
        <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <router-link :to="`/dashboard/familias/edit/${item.id}`" class="btn btn-default">
              <i class="mdi mdi-arrow-left" />
            </router-link>

            <a class="btn btn-sm py-1 btn-primary" @click="print()">
              <i class="mdi mdi-printer mdi-18px" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: [],
      unidades: [],
      per_capita_familiar: 0,
      renda_total_familiar: 0,
      beneficiosValor: 0,
      programasValor: 0,
      beneficios: [],
      programas: []
    };
  },
  mounted() {
    this.getUnidades();
    this.getServicos();
    this.getItem();
  },
  computed: {
    sumRendas() {
      this.renda_total_familiar = this.item && this.item.renda_calculo
        ? this.checkValue(this.item.renda_calculo)
        : this.financeiro && this.financeiro.renda_total_familiar
          ? this.checkValue(this.financeiro.renda_total_familiar)
          : 0;

      this.per_capita_familiar = this.item && this.item.renda_calculo && this.item.familiares
        ? parseInt(this.checkValue(this.item.renda_calculo)) / this.item.familiares.length
        : this.financeiro && this.financeiro.per_capita_familiar
          ? parseInt(this.checkValue(this.financeiro.per_capita_familiar)) / 100
          : 0;

      
      var sumBeneficio = 0;
      var sumProgramas = 0;

      // Verifica se `this.item` e suas propriedades existem antes de acessá-las
      this.beneficios = this.item && this.item.beneficiosEventuais ? this.item.beneficiosEventuais : [];
      this.programas = this.item && this.item.programas_sociais ? this.item.programas_sociais : [];

      // Faz o loop apenas se os arrays existirem
      this.beneficios.forEach((elem) => {
        sumBeneficio += elem.valor;
      });

      this.programas.forEach((elem) => {
        sumProgramas += elem.valor;
      });

      // Define os valores de benefícios e programas
      this.beneficiosValor = sumBeneficio;
      this.programasValor = sumProgramas;

      // Retorna o total da renda familiar
      return this.renda_total_familiar;
    }
    ,
  },
  methods: {
    getItem() {
      axios
        .get(`api/dashboard/familias/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push("/dashboard/familias/");
        });
    },
    getServicos() {
      axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
        this.servicos = response.data;
      });
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/PLANTAO`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
    pergunta(item) {
      var value = item == 1 ? 0 : 1;
      return this.$root.arrays.pergunta[value].value;
    },
    checkProhab(prohab) {
      const result = this.$root.arrays.programas_prohab.filter(
        (item) => item.id == prohab
      );
      return result ? result[0].value : "";
    },
    checkSesan(servicos) {
      if (this.item.programas_servicos) {
        return this.item.programas_servicos[servicos] &&
          this.item.programas_servicos[servicos] != null
          ? true
          : false;
      } else {
        return false;
      }
    },
    verificarValueArray(value, array, valueIsArray = false) {
      if (valueIsArray && value) {
        var a = "";
        for (var i = 0; i < value.length; i++) {
          //console.log(value[i]);
          const result = array.filter((item) => item.id == value[i]);
          a += result[0].value + (i < value.length - 1 ? "," : "");
          //console.log(a);
        }

        return a;
      } else {
        const result = array.filter((item) => item.id == value);
        return result[0] ? result[0].value : "";
      }
    },
    findFrequentaEscola(frequenta_escola) {
      const frequenta = this.$root.arrays.frequenta_escola.find(
        (element) => element.id == frequenta_escola
      );

      return frequenta ? frequenta.value : "";
    },
    findFrequentou(curso_frequentou) {
      const frequentou = this.$root.arrays.curso_frequentou.find(
        (element) => element.id == curso_frequentou
      );
      return frequentou ? frequentou.value : "";
    },
    findFrequenta(curso_frequenta) {
      const frequenta = this.$root.arrays.curso_frequenta.find(
        (element) => element.id == curso_frequenta
      );
      return frequenta ? frequenta.value : "";
    },
    checkEfeito(efeito) {
      const result = this.$root.arrays.efeito_descumprimento.filter(
        (item) => item.id == efeito
      );
      return result ? result[0].value : "";
    },
    checkValue(a) {
      return a == null ? 0 : parseInt(a);
    },
    findJob(profissao_principal) {
      const job = this.$root.arrays.profissao_principal.find(
        (element) => element.id == profissao_principal
      );
      return job ? job.value : "";
    },
    changeNome(nome) {
      return nome != undefined || nome != null ? "," + nome : "";
    },
    checkValue(a) {
      return a == null ? 0 : parseInt(a);
    },
    checkPendencias(pendencia) {
      if (this.item.pendencias) {
        return this.item.pendencias[pendencia] ? true : false;
      } else {
        return null;
      }
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
  },
};
</script>

<style scoped>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.bg-danger {
  background: #fb8994 !important;
  color: #424242 !important;
}

.bg-success {
  background: #a5d6a7 !important;
  color: #424242 !important;
}
</style>
